/*
 view-paysafecard

 paysafecard = {
 "utimestamp": 1458224412998,
 "am": "50",
 "paymentMethodId": ,
 }
 */
import core from '../../common/lib/core.js';

const create = core.create;
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
const notvalidClass = 'payment__input_notvalid';

function createFieldsetWrapNumber(eventFilter) {
	const cName = `${eventFilter} payments__fieldset-wrap-number u-relative`;
	return create({
		type: 'div',
		class: cName
	});
}

function userInputToSubmitStructure() {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */

	const allvalid = Boolean(true);
	return {
		allvalid,
		utimestamp: new Date().getTime(),
		paymentMethodId: 6
	};
}

function show(elm) {
	core.removeClass(elm, classnameHide);
	core.addClass(elm, classnameShow);
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function hideElm(elm, yesHideIt) {
	if (yesHideIt) {
		hide(elm);
	} else {
		show(elm);
	}
}

function markValid(element, valid) {
	if (valid) {
		core.removeClass(element, notvalidClass);
	} else {
		core.addClass(element, notvalidClass);
	}
}

function feedbackToCode(inputIsValid, elms) {
	if (inputIsValid) {
		markValid(elms.labelcardnumber, true);
		hide(elms.cardnumberfeedback);
	} else {
		markValid(elms.labelcardnumber, false);
		hideElm(elms.cardnumberfeedback, false);
	}
}

function markValidAll(uInput, elements) {
	/* depending on validation the inputfields are marked
    with specific classname and messages with feedback are shown */
	const code = (uInput && uInput.blik);
	feedbackToCode(code, elements);
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

export default {
	create() {
		let elements = {};
		const mainEventType = 'input';
		const classNameEventFilter = 'js-eventfilter-viewpaysafecard';
		elements.wrap = (elements.wrap || createFieldsetWrapNumber(classNameEventFilter));
		const callbackOnMainEvent = function temp() {};
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);

		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update() {},
			evalInput() {
				let uinput = userInputToSubmitStructure(elements);
				markValidAll(uinput, elements);
				uinput = (uinput.allvalid ? uinput : null);
				return uinput;
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_paysafecard:248');
				return null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-paysafecard.js